export default __webpack_public_path__ + "static/media/news67.7945b098.jpg";